import React, { useState, useEffect, useMemo } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useAnalytics } from '../contexts/AnalyticsContext';
import { subMinutes, isAfter } from 'date-fns';

const { FiActivity, FiZap } = FiIcons;

const RealTimeUsers = () => {
  const { analyticsData } = useAnalytics();
  
  // Calculate real pulse based on activity in the last 5 minutes
  const activeNow = useMemo(() => {
    const fiveMinutesAgo = subMinutes(new Date(), 5);
    const recentViews = (analyticsData.pageViews || []).filter(pv => 
      isAfter(new Date(pv.timestamp), fiveMinutesAgo)
    );
    return new Set(recentViews.map(pv => pv.sessionId)).size;
  }, [analyticsData.pageViews]);

  return (
    <div className="bg-[#673ab7] rounded-3xl p-8 text-white relative overflow-hidden shadow-xl shadow-blue-900/10">
      <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div>
          <div className="flex items-center gap-2 text-indigo-200 text-[10px] font-black uppercase tracking-[0.2em] mb-3">
            <div className={`w-2.5 h-2.5 rounded-full ${activeNow > 0 ? 'bg-green-400 animate-pulse' : 'bg-slate-400'}`}></div> 
            Live Production Pulse
          </div>
          <h2 className="text-6xl font-black tracking-tighter">{activeNow}</h2>
          <p className="text-indigo-100/80 text-sm font-medium mt-2">
            Unique active sessions detected in the last 5 minutes.
          </p>
        </div>
        
        <div className="flex gap-4">
          <div className="bg-white/10 p-5 rounded-2xl backdrop-blur-md border border-white/10 min-w-[140px]">
            <div className="text-[10px] uppercase font-black text-indigo-200 tracking-widest mb-1">Status</div>
            <div className="text-lg font-black flex items-center gap-2">
              {activeNow > 0 ? 'RECEIVING' : 'WAITING'}
              <SafeIcon icon={FiZap} className={activeNow > 0 ? 'text-yellow-400' : 'text-slate-400'} />
            </div>
          </div>
        </div>
      </div>
      <div className="absolute top-0 right-0 p-8 opacity-[0.05] pointer-events-none">
        <SafeIcon icon={FiActivity} className="w-64 h-64" />
      </div>
    </div>
  );
};

export default RealTimeUsers;